/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Tournaments_Lib_Pairing_Label_TableInputs */



/**
* | output |
* | --- |
* | "Table {number}" |
*
* @param {Tournaments_Lib_Pairing_Label_TableInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_pairing_label_table = /** @type {((inputs: Tournaments_Lib_Pairing_Label_TableInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Pairing_Label_TableInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tisch ${i?.number}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Table ${i?.number}`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`${i?.number} 号桌`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`第 ${i?.number} 桌`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`테이블 ${i?.number}`)
	return /** @type {LocalizedString} */ (`Table ${i?.number}`)
});